import * as React from 'react'
import * as styles from './LiveBadge.module.scss'
import BasicBadge from './BasicBadge'

interface LiveBadgeProps {
  label: string
  status: string
  isStandalone: boolean
}

const LiveBadge = ({ label, status, isStandalone }: LiveBadgeProps) => {
  if (!status || !label) {
    return null
  }
  const classNames = [{ [styles.isStandalone]: isStandalone }, styles.LiveBadge]
  return (
    <BasicBadge classNames={classNames}>
      {label}
    </BasicBadge>
  )
}

export default LiveBadge
